import { generatePixObject } from './assembler';
import { PixElementType, } from './types/pixElements';
const defaultPixFields = {
    merchantCategoryCode: '0000',
    transactionCurrency: '986',
    countryCode: 'BR',
};
const defaultStaticFields = {
    ...defaultPixFields,
    isTransactionUnique: false,
    txid: '***',
};
export function createStaticPix(params) {
    if (params.merchantName.length > 25)
        return {
            error: true,
            message: 'merchantName character limit exceeded (> 25)',
            throwIfError: () => {
                throw new Error('merchantName character limit exceeded (> 25)');
            },
        };
    if (params.merchantCity.length > 15)
        return {
            error: true,
            message: 'merchantCity character limit exceeded (> 15)',
            throwIfError: () => {
                throw new Error('merchantCity character limit exceeded (> 15)');
            },
        };
    if (params.txid && params.txid.length > 25)
        return {
            error: true,
            message: 'txid character limit exceeded (> 25)',
            throwIfError: () => {
                throw new Error('txid character limit exceeded (> 25)');
            },
        };
    const elements = {
        type: PixElementType.STATIC,
        ...defaultStaticFields,
        ...params,
    };
    return generatePixObject(elements);
}
export function createDynamicPix(params) {
    if (params.merchantName.length > 25)
        return {
            error: true,
            message: 'merchantName character limit exceeded (> 25)',
            throwIfError: () => {
                throw new Error('merchantName character limit exceeded (> 25)');
            },
        };
    if (params.merchantCity.length > 15)
        return {
            error: true,
            message: 'merchantCity character limit exceeded (> 15)',
            throwIfError: () => {
                throw new Error('merchantCity character limit exceeded (> 15)');
            },
        };
    const elements = {
        type: PixElementType.DYNAMIC,
        ...defaultStaticFields,
        ...params,
        merchantCity: params.merchantCity.substr(0, 15).toUpperCase(),
    };
    return generatePixObject(elements);
}
//# sourceMappingURL=data:application/json;base64,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